// index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { CssBaseline, ThemeProvider } from '@mui/material';
import App from './App';
import { AuthProvider } from '@/contexts/AuthProvider';
import { initialiseApi } from '@/api/core/initialiseApi';

// Nunito Sans with the weight and width axes (font-stretch 75%–125%), self-hosted by Vite
import '@fontsource-variable/nunito-sans/wdth.css';
import './styles/base/index.scss';
import theme from './styles/base';
import { loadPreviewFont } from './styles/base/previewFonts';

initialiseApi();
loadPreviewFont();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found!');

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            {/* color-scheme from palette.mode: native scrollbars, date inputs and autofill follow the dark theme */}
            <CssBaseline enableColorScheme />
            <AuthProvider>
                <App />
            </AuthProvider>
            <ToastContainer />
        </ThemeProvider>
    </React.StrictMode>
);
